import React from 'react';
import styled from 'styled-components';

import Progress from 'antd/es/progress';

import { Text } from 'components/Text';

const CartCountWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const CartCountHeader = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 12px;

  // text styling
  font-weight: 600;
  font-size: 14px;
  line-height: 22px;
  text-align: center;
  color: #232526;

  > *:nth-child(odd) {
    margin-right: 8px;
  }
`;

const CartCountValueWrapper = styled.span`
  display: flex;
  flex-direction: column;
  align-itens: center;

  > .count {
    display: block;
    font-weight: 600;
    font-size: 30px;
    line-height: 38px;
    color: #232526;
  }

  > .percentage {
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    text-align: center;
    color: #45494D
  }
`;

const StyledProgress = styled(Progress)`
  width: 160px;
  height: 160px;

  & .ant-progress-inner {
    width: 100% !important;
    height: 100% !important;
  }
`;

const CartCountValue = ({ count, percentage }) => {
  return (
    <CartCountValueWrapper>
      <Text className="count">{count}</Text>
      <Text className="percentage">{`${percentage}%`}</Text>
    </CartCountValueWrapper>
  );
}

const CartCountStat = ({ name, icon, count, percentage, color = '#979899' }) => {
  return (
    <CartCountWrapper>
      <CartCountHeader>
        {icon && icon}
        {name}
      </CartCountHeader>
      <StyledProgress
        type="circle"
        strokeLinecap='square'
        strokeColor={color}
        format={() => {
          return (
            <CartCountValue
              count={count}
              percentage={percentage}
            />
          );
        }}
        strokeWidth={9}
        percent={percentage}
      />
  </CartCountWrapper>
  );
};

export default CartCountStat;